import { SunVector } from '@frontend/web-icons';
import { Text, YStack } from '@frontend/web-react';

export const EmptyTasksContainer = () => (
  <YStack className="grow-1 py-xl justify-center items-center gap-lg bg-gradient-to-b from-rose-200 to-blue-100 rounded-lg">
    <SunVector />
    <YStack className="gap-xs">
      <Text color="secondary" textAlign="center" type="h4">
        Your tasks will show up here.
      </Text>
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <Text className="max-w-[400px] font-normal" color="tertiary" textAlign="center" type="h5">
        {"We'll"} let you know when {"there's"} something to review. Check back anytime.
      </Text>
    </YStack>
  </YStack>
);
